<template>
  <div class="Invoices animated fadeIn">
    <MuiGridContainer
      :fluid="false"
      class="TemplateDefault__container"
    >
      Invoices Page
    </MuiGridContainer>
  </div>
</template>

<script>

import { MuiGridContainer } from '@ubeeqo/motion-ui';

export default {
  name: 'InvoicesView',
  components: {
    MuiGridContainer,
  },
  data() {
    return {
      tabsData: {},
    };
  },
  methods: {},
};
</script>
